/* eslint-disable */
// DO NOT LINT THIS FILE!! -RG

import 'whatwg-fetch';
import Es6Promise from 'es6-promise';
import values from 'object.values';

require('es6-weak-map/implement');
require('es6-symbol/implement');
require('@formatjs/intl-relativetimeformat/polyfill');
require('@formatjs/intl-relativetimeformat/locale-data/en');
require('@formatjs/intl-relativetimeformat/locale-data/ko');
require('@formatjs/intl-relativetimeformat/locale-data/es');
require('@formatjs/intl-relativetimeformat/locale-data/pt');

Es6Promise.polyfill();

// Object assign
if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
        enumerable: false,
        configurable: true,
        writable: true,
        value(target) {
            if (target === undefined || target === null) {
                throw new TypeError('Cannot convert first argument to object');
            }

            const to = Object(target);
            for (let i = 1; i < arguments.length; i += 1) {
                let nextSource = arguments[i];
                if (nextSource === undefined || nextSource === null) {
                    continue;
                }
                nextSource = Object(nextSource);

                const keysArray = Object.keys(nextSource);
                for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
                    const nextKey = keysArray[nextIndex];
                    const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                    if (desc !== undefined && desc.enumerable) {
                        to[nextKey] = nextSource[nextKey];
                    }
                }
            }
            return to;
        }
    });
}

if (!Object.values) {
    values.shim();
}

// number.toLocaleDateString
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString#Example:_Checking_for_support_for_locales_and_options_arguments
function toLocaleStringSupportsLocales() {
    const number = 0;
    try {
        number.toLocaleString('i');
    } catch (e) {
        return e.name === 'RangeError';
    }
    return false;
}

if (!toLocaleStringSupportsLocales()) {
    const replaceSeparators = (sNum, separators) => {
        const sNumParts = sNum.split('.');
        if (separators && separators.thousands) {
            sNumParts[0] = sNumParts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${separators.thousands}`);
        }
        sNum = sNumParts.join(separators.decimal);

        return sNum;
    };

    const renderFormat = (template, props) => {
        for (const prop in props) {
            template = template.replace(`{{${prop}}}`, props[prop]);
        }

        return template;
    };

    const mapMatch = function (map, locale) {
        let match = locale;
        const language = locale && locale.toLowerCase().match(/^\w+/);

        if (!map.hasOwnProperty(locale)) {
            if (map.hasOwnProperty(language)) {
                match = language;
            } else {
                match = 'en';
            }
        }

        return map[match];
    };

    const dotThousCommaDec = (sNum) => {
        const separators = {
            decimal: ',',
            thousands: '.'
        };

        return replaceSeparators(sNum, separators);
    };

    const commaThousDotDec = (sNum) => {
        const separators = {
            decimal: '.',
            thousands: ','
        };

        return replaceSeparators(sNum, separators);
    };

    const spaceThousCommaDec = (sNum) => {
        const seperators = {
            decimal: ',',
            thousands: '\u00A0'
        };

        return replaceSeparators(sNum, seperators);
    };

    const transformForLocale = {
        en: commaThousDotDec,
        it: dotThousCommaDec,
        fr: spaceThousCommaDec,
        de: dotThousCommaDec,
        'de-DE': dotThousCommaDec,
        'de-AT': dotThousCommaDec,
        'de-CH': dotThousCommaDec,
        'de-LI': dotThousCommaDec,
        'de-BE': dotThousCommaDec,
        ro: dotThousCommaDec,
        'ro-RO': dotThousCommaDec,
        hu: spaceThousCommaDec,
        'hu-HU': spaceThousCommaDec
    };

    const currencyFormatMap = {
        en: 'pre',
        it: 'post',
        fr: 'post',
        de: 'post',
        'de-DE': 'post',
        'de-AT': 'prespace',
        'de-CH': 'prespace',
        'de-LI': 'post',
        'de-BE': 'post',
        ro: 'post',
        'ro-RO': 'post',
        hu: 'post',
        'hu-HU': 'post'
    };

    const currencySymbols = {
        eur: '€',
        usd: '$',
        ron: 'RON',
        krw: '₩',
        jpy: '￥',
        huf: 'HUF'
    };

    const currencyFormats = {
        pre: '{{code}}{{num}}',
        post: '{{num}} {{code}}',
        prespace: '{{code}} {{num}}'
    };

    Number.prototype.toLocaleString = function (locale, options) {
        if (locale && locale.length < 2) throw new RangeError(`Invalid language tag: ${locale}`);

        let sNum;

        if (options && options.minimumFractionDigits) {
            sNum = this.toFixed(options.minimumFractionDigits);
        } else {
            sNum = this.toString();
        }

        sNum = mapMatch(transformForLocale, locale)(sNum, options);

        if (options && options.currency && options.style === 'currency') {
            const format = currencyFormats[mapMatch(currencyFormatMap, locale)];
            if (options.currencyDisplay === 'code') {
                sNum = renderFormat(format, {
                    num: sNum,
                    code: options.currency.toUpperCase()
                });
            } else {
                sNum = renderFormat(format, {
                    num: sNum,
                    code: currencySymbols[options.currency.toLowerCase()]
                });
            }
        }

        return sNum;
    };
}

// String startsWith
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        return this.substr(position || 0, searchString.length) === searchString;
    };
}

// Array Includes
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value(searchElement, fromIndex) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            const o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            const len = o.length >>> 0;

            // 3. If len is 0, return false.
            if (len === 0) {
                return false;
            }

            // 4. Let n be ? ToInteger(fromIndex).
            //    (If fromIndex is undefined, this step produces the value 0.)
            const n = fromIndex | 0;

            // 5. If n ≥ 0, then
            //  a. Let k be n.
            // 6. Else n < 0,
            //  a. Let k be len + n.
            //  b. If k < 0, let k be 0.
            let k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            // 7. Repeat, while k < len
            while (k < len) {
                // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                // b. If SameValueZero(searchElement, elementK) is true, return true.
                // c. Increase k by 1.
                // NOTE: === provides the correct "SameValueZero" comparison needed here.
                if (o[k] === searchElement) {
                    return true;
                }
                k += 1;
            }

            // 8. Return false
            return false;
        }
    });
}

// String Includes
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {
        if (typeof start !== 'number') {
            start = 0;
        }

        if (start + search.length > this.length) {
            return false;
        }
        return this.indexOf(search, start) !== -1;
    };
}

/**
 * BEGIN Github Poly fills for iterators
 */
function iterator() {
    const self = this;
    let i = 0;
    return {
        next() {
            return {
                done: i === self.length,
                value: self[(i += 1)]
            };
        }
    };
}

if (!Array.prototype[Symbol.iterator]) {
    Array.prototype[Symbol.iterator] = iterator;
}

if (!NodeList.prototype[Symbol.iterator]) {
    // IE11 refuses to assign directly onto NodeList.prototype
    Object.defineProperty(NodeList.prototype, Symbol.iterator, {
        enumerable: false,
        configurable: true,
        get() {
            return iterator;
        }
    });
}

if (!HTMLCollection.prototype[Symbol.iterator]) {
    // IE11 refuses to assign directly onto HTMLCollection.prototype
    Object.defineProperty(HTMLCollection.prototype, Symbol.iterator, {
        enumerable: false,
        configurable: true,
        get() {
            return iterator;
        }
    });
}

if (window.Headers && !Headers.prototype[Symbol.iterator]) {
    Headers.prototype[Symbol.iterator] = function () {
        const items = [];
        this.forEach((value, name) => {
            items.push([name, value]);
        });
        return items[Symbol.iterator]();
    };
}

/**
 * END Github Poly fills for iterators
 */

// Number.isNaN
Number.isNaN =
    Number.isNaN ||
    function (value) {
        return value !== value;
    };
